// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconPin = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M11.75 23.58c-.42 0-.8-.21-1.02-.56C8.71 19.86 4 12.15 4 8.75 4 4.48 7.48 1 11.75 1s7.75 3.48 7.75 7.75c0 3.39-4.7 11.1-6.73 14.26-.22.36-.6.57-1.02.57zm0-21.08C8.3 2.5 5.5 5.3 5.5 8.75c0 2.38 3.18 8.25 6.25 13.08C14.82 17 18 11.13 18 8.75c0-3.44-2.8-6.25-6.25-6.25zm0 9.8a3.55 3.55 0 11.002-7.102 3.55 3.55 0 01-.002 7.102zm0-5.6c-1.13 0-2.05.92-2.05 2.05s.92 2.05 2.05 2.05 2.05-.92 2.05-2.05-.92-2.05-2.05-2.05z"
      fill="currentColor"
    />
  );
export default SvgIconPin;
